module.exports = __webpack_public_path__ + "img/marksmanship.9b80f7e7.jpg";